import $ from 'jquery';
import {Swiper, Navigation, Autoplay} from 'swiper/swiper.esm.js';
Swiper.use([Navigation, Autoplay]);

$('.sports-swiper').each(function () {
    const $self = $(this);
    const $section = $self.closest('section');

    const swiper = new Swiper($self[0], {
        slidesPerView: 1,
        loop: true,
        navigation: {
            nextEl: $self.closest('.section').find('.sports-swiper-button-next')[0],
            prevEl: $self.closest('.section').find('.sports-swiper-button-prev')[0],
        }
    });
});